<template>
  <div
    class="absolute top-0 left-0 w-full h-screen pointer-events-none z-0"
    style="background: linear-gradient(180deg, #66adff 0%, #ffffff 40%)"
  ></div>
</template>
